import React from 'react';
import { Button } from './ui/Button';
import { ShieldCheck, Users } from 'lucide-react';
export function Hero() {
  return <section className="pt-8 pb-16 md:pt-16 md:pb-24 px-4 max-w-7xl mx-auto" data-id="element-46">
      <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-47">
        <div className="flex flex-col space-y-6 md:pr-8" data-id="element-48">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 leading-tight tracking-tight" data-id="element-49">
            Find Out What You Should Really Pay for Your Windows{' '}
            <span className="text-orange-500" data-id="element-50">(in Under 30 Seconds)</span>
          </h1>

          <p className="text-lg md:text-xl text-gray-600 leading-relaxed" data-id="element-51">
            Compare real quotes from trusted local companies and save hundreds —
            at no cost to you.
          </p>

          <div className="pt-4 flex flex-col items-start space-y-4" data-id="element-52">
            <a href="https://www.apwkk8trk.com/94J6RZ/293Z4R/" className="w-full sm:w-auto block decoration-transparent" data-id="element-53">
              <Button size="xl" fullWidth className="sm:w-auto" data-id="element-54">
                Compare Prices Now &rarr;
              </Button>
            </a>

            <div className="flex flex-col space-y-2" data-id="element-55">
              <div className="flex items-center text-sm text-gray-500 font-medium" data-id="element-56">
                <ShieldCheck className="w-4 h-4 mr-2 text-green-500" data-id="element-57" />
                No commitment required. Just real prices.
              </div>
              <div className="flex items-center text-sm text-gray-500 font-medium animate-pulse" data-id="element-58">
                <Users className="w-4 h-4 mr-2 text-orange-500" data-id="element-59" />
                127 homeowners compared prices today
              </div>
            </div>
          </div>
        </div>

        <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[4/3] md:aspect-auto md:h-[600px]" data-id="element-60">
          <img src="https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&q=80" alt="Modern home with beautiful large windows" className="absolute inset-0 w-full h-full object-cover" loading="eager" data-id="element-61" />
          {/* Subtle gradient overlay to make it look premium */}
          <div className="absolute inset-0 bg-gradient-to-tr from-black/10 to-transparent" data-id="element-62"></div>
        </div>
      </div>
    </section>;
}